module.exports = __webpack_public_path__ + "img/footer_logo_comscore.6ff885ea.png";